import { createRouter, createWebHashHistory } from 'vue-router';

const routes = [
  {
    name: 'notFound',
    path: '/:path(.*)+',
    redirect: {
      name: 'download',
    },
  },
  {
    name: 'login',
    path: '/login',
    component: () => import('./view/login'),
    meta: {
      title: '登录',
    },
  },
  // {
  //   name: 'publish',
  //   path: '/publish',
  //   component: () => import('./view/publish'),
  //   meta: {
  //     title: '发布',
  //   },
  // },
  {
    name: 'download',
    path: '/download',
    component: () => import('./view/download'),
    meta: {
      title: '起泡',
    },
  },
  {
    name: 'openapp',
    path: '/openapp',
    component: () => import('./view/openapp'),
    meta: {
      title: '起泡AI',
    },
  },
  {
    name:'official',
    path: '/official',
    component: () => import('./view/official'),
    meta: {
      title: '看历史 聊文化 找圈子 上起泡',
    },
  },
  {
    name: 'privary',
    path: '/privary',
    component: () => import('./view/privary'),
    meta: {
      title: '隐私政策',
    },
  },
    {
    name: 'privaryContent',
    path: '/privarycontent',
    component: () => import('./view/privaryContent'),
    meta: {
      title: '隐私政策',
    },
  },
  {
    name: 'creatorContest',
    path: '/creator-contest',
    component: () => import('./view/creatorContest'),
    meta: {
      title: '「来起泡 发视频 赢大奖」首届泛文化视频共创大赛',
    },
  },
  {
    name: 'creatorContestRules',
    path: '/creator-contest/rules',
    component: () => import('./view/creatorContestRules'),
    meta: {
      title: '活动规则',
    },
  },
  {
    name: 'otherUserHome',
    path: '/user/:beUserId?',
    component: () => import('./view/otherUserHome'),
    meta: {
      title: '个人主页',
    },
  },
  {
    name: 'postImageDetail',
    path: '/post/image/:postId?',
    component: () => import('./view/postImageDetail'),
    meta: {
      title: '作品详情',
    },
  },
  {
    name: 'postVideoDetail',
    path: '/post/video/:postId?',
    component: () => import('./view/postVideoDetail'),
    meta: {
      title: '作品详情',
    },
  },
  {
    name: 'postVideoPlayDetail',
    path: '/post/video-detail',
    component: () => import('./view/postVideoDetail'),
    meta: {
      title: '作品详情',
    },
  },
  // 直播分享落地页：App 端分享链接 `#/live/<流名>`，未安装时引导下载。
  // 兜底路由 `/:path(.*)+` 会把未知路径重定向到下载页，本路由必须存在，
  // 否则直播分享出去的链接点开就是下载页。
  {
    name: 'liveDetail',
    path: '/live/:id?',
    component: () => import('./view/liveDetail'),
    meta: {
      title: '起泡直播',
    },
  },
    {
    name: 'paopao',
    path: '/paopaoh5',
    component: () => import('./view/paopaoH5'),
    meta: {
      title: '活动',
    },
  },
];

const router = createRouter({
  routes,
  history: createWebHashHistory(),
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export { router };
